import { attach as attachFwnAnalytics } from '@assets/fwnInit/fwnAnalytics'
import { attach as attachConsole } from '@assets/fwnInit/fwnConsole'
import { attach as attachFwnCookies } from '@assets/fwnInit/fwnCookies'
import { attach as attachLiveHelper } from '@assets/fwnInit/fwnLiveHelper'
import { init } from '@assets/fwnInit/init'
import { collectEntrypointConfig } from '@core/globalConfig'

import '../agent-status-element'
import '../live-helper-element'

init(() => {
  collectEntrypointConfig()
  attachFwnCookies()
  attachFwnAnalytics()
  attachConsole()
  attachLiveHelper()
})
